export namespace uuid {
  // Borrowed from https://stackoverflow.com/a/2117523/43687

  export type UuidFunc = () => string;
  export type PrefixUuidFunc = (prefix: string) => string;

  export function getUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      // tslint:disable-next-line:no-bitwise
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  export function idWithPrefix(prefix: string) {
    return `${prefix}-${getUuid()}`;
  }
}
